import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import '../../../../assets/css/partials/PartsList.css'
import { Checkbox } from '@mui/material'
import moment from 'moment'

function PartsList({ recentParts, loading }) {
    const actionLabels = {
        'load': {
            label: trans('partStatuses.inStock'),
            color: '#22C55E'
        },
        'unload': {
            label: trans('partStatuses.found'),
            color: '#F59E0B'
        },
        'sold': {
            label: trans('partStatuses.confirmed'),
            color: '#EF4444'
        },
        'ordered': {
            label: trans('partStatuses.ordered'),
            color: '#3B82F6'
        },
        'new': {
            label: trans('partStatuses.new'),
            color: '#8B5CF6'
        },
        'reserved': {
            label: trans('partStatuses.reserved'),
            color: '#F59E0B'
        },
        'delivered': {
            label: trans('partStatuses.delivered'),
            color: '#22C55E'
        },
        'returned': {
            label: trans('partStatuses.returned'),
            color: '#EF4444'
        },
        'damaged': {
            label: trans('partStatuses.waiting'),
            color: '#F59E0B'
        }
    }

    if (loading) {
        return <Skeleton height={60} count={6} />
    }

    if (recentParts.length === 0) {
        return (
            <div className="alert info">
                {trans('messages.noDataFound')}
            </div>
        )
    }

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('labels.part')}</th>
                    <th>{trans('labels.status')}</th>
                    <th>{trans('tables.addedAt')}</th>
                </tr>
            </thead>

            <tbody>
                {recentParts.map((part, idx) => (
                    <tr key={part.id}>
                        <td>
                            {part.part_name}
                        </td>
                        <td>
                            <div className='action'>
                                {part.action || part.status ?
                                    <>
                                        <span
                                            style={{
                                                backgroundColor: part?.color || '#E5E7EB'
                                            }}
                                        >

                                        </span>
                                        {actionLabels[part.action]?.label || part.action || part.status || '-'}
                                    </>
                                    :
                                    '-'
                                }
                            </div>
                        </td>
                        <td>
                            {moment(part.date).format('DD.MM.YYYY / HH:mm')}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default PartsList